module.exports = __webpack_public_path__ + "static/media/27.2ea62638.mp3";